import { flatten, join, pathOr, pipe, values } from 'ramda'
import { isOnline as checkIsOnline } from 'ducks/offline/actions'

export const extractMessageFromErrorResponse = pathOr('Something went wrong', [
  'response',
  'data',
  'message'
])

export const isNetworkError = error =>
  !checkIsOnline() ||
  error?.message === 'Network Error' ||
  error?.code === 'ERR_NETWORK'

export const getApiErrors = error => {
  // Suppress error toasts when offline or network fails
  if (isNetworkError(error)) return ''

  // Don't show errors for cancelled requests
  if (error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError') return ''

  const errors = pipe(
    pathOr({}, ['response', 'data', 'errors']),
    values,
    flatten
  )(error)

  const filteredErrors = Array.isArray(errors)
    ? errors.filter(err => err !== 'Unauthenticated.')
    : errors

  const joinedErrors = Array.isArray(filteredErrors)
    ? join('\n', filteredErrors)
    : filteredErrors

  // Check for "Unauthenticated." in the message field as well
  const message = extractMessageFromErrorResponse(error)
  if (message === 'Unauthenticated.') {
    return '' // Return empty string or alternative message
  }

  return joinedErrors || message || 'An error occurred'
}

export const apiErrorMessage = (error, fallback = 'Something went wrong') =>
  error?.response?.data?.message || error?.response?.data?.error || fallback

export const isSharePointTokenExpired = error => {
  const errorCode = error?.response?.data?.errorCode
  const requiresReauth = error?.response?.data?.requiresReauth
  return errorCode === 'sharepoint_token_expired' || requiresReauth === true
}
